import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "_rounded--common _bxsh--base _fo",
  role: "region",
  "aria-label": "Become a creator statistics"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_become_a_creator_section = _resolveComponent("become-a-creator-section")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_become_a_creator_section, { "creator-statistics": $setup.creatorStatistics }, null, 8 /* PROPS */, ["creator-statistics"])
  ]))
}